export { SetupResults, default } from './SetupResults';
